
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/learn/fitness",
      function () {
        return require("private-next-pages/learn/fitness/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/learn/fitness"])
      });
    }
  